import { render, staticRenderFns } from "./Sucessresult.vue?vue&type=template&id=c36c5056&scoped=true&"
import script from "./Sucessresult.vue?vue&type=script&lang=js&"
export * from "./Sucessresult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36c5056",
  null
  
)

export default component.exports